import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Request from "../../../utilities/Request.jsx";
import Card from "../../components/Card.jsx";
import TextInput from "../../elements/TextInput.jsx";
import Button from "../../components/Button.jsx";
import InputSwitch from "../../components/InputSwitch.jsx";
import useLoggedInUser from "../../hooks/useLoggedInUser.js";

export default function ChangePasswordSettingsForm() {
	const [password, updatePassword] = useState('');
	const [submitting, updateSubmitting] = useState(false);
	const [error, updateError] = useState(false);
	const [showPassword, updateShowPassword] = useState(false);
	const [passwordUpdated, updatePasswordUpdated] = useState(null);

	const player = useLoggedInUser();

	function inputChange(event) {
		switch(event.target.name) {
			case 'password':
				updatePassword(event.target.value);
				break;
		}
		updateError(false);
	}

	function toggleShowPassword(event) {
		updateShowPassword(event.target.checked);
	}

	function submitPasswordChange(event) {
		event.preventDefault();
		updateSubmitting(true);
		updatePasswordUpdated(null);
		Request.apiv1Post('player/password_change', { password: password })
			.then((response) => {
				updatePassword('');
				updatePasswordUpdated('Password Changed!');
			})
			.catch(async(response) => {
				updateError(await Request.parseError(response));
			})
			.finally(() => {
				updateSubmitting(false);
			});
	}

	return (
		<form
			onSubmit={submitPasswordChange}>
			<Card cardTitle='Change Password'
			      cardAction={
				      <Button
					      disabled={password === ''}
					      onClick={submitPasswordChange}
				      >
					      Change Password
				      </Button>
			      }
			>
				<div className='row'>
					<input className='for-accessibility' type='hidden' name='username'
					       value={player.email ?? ''}
					       autoComplete='username' />
					<div className='input-field col s12 m12 l6'>
						<TextInput
							disabled={submitting}
							onChange={inputChange}
							value={password}
							className='validate'
							type={showPassword ? 'text' : 'password'}
							name='password'
							id='password'
							autoComplete='new-password'
							label='Enter Your New Password'
						/>
					</div>
					<InputSwitch
						onChange={toggleShowPassword}
					>
						Show Password
					</InputSwitch>
					<div className='col s12'>
						<div className='error error_message'>
							{error}
						</div>
					</div>
					{!!passwordUpdated &&
					<div className='col s12'>
						{passwordUpdated}
					</div>
					}
				</div>
			</Card>
		</form>
	);
}